import { useSchoolFeaturesForMonitoringQuery } from '@/types/vue-apollo-helpers';
import { MONITORING_FEATURE_CODE } from '../types';

export function useMonitoringFeatureGate() {
  const { result, loading } = useSchoolFeaturesForMonitoringQuery({
    fetchPolicy: 'cache-first',
  });

  const enabled = computed(() => {
    const features = result.value?.schoolFeatures ?? [];
    const match = features.find((f) => f.code === MONITORING_FEATURE_CODE);
    return Boolean(match?.enabled);
  });

  return { enabled, loading };
}
